import { isMobileDevice } from "~~/utils";

export default function useSocialLogin() {
	const { ORIGIN } = useRuntimeConfig().public;

	const POPUP_WIDTH = 400;
	const POPUP_HEIGHT = 500;

	const screenLeft = computed<number>(() =>
		window?.screenLeft !== undefined ? window?.screenLeft : window?.screenX
	);
	const screenTop = computed<number>(() =>
		window?.screenTop !== undefined ? window?.screenTop : window?.screenY
	);

	const screenWidth = computed<number>(
		() =>
			window?.innerWidth || document.documentElement.clientWidth || screen.width
	);
	const screenHeight = computed<number>(
		() =>
			window?.innerHeight ||
			document.documentElement.clientHeight ||
			screen.height
	);

	const left = computed<number>(
		() => screenLeft.value + (screenWidth.value - POPUP_WIDTH) / 2
	);
	const top = computed<number>(
		() => screenTop.value + (screenHeight.value - POPUP_HEIGHT) / 2
	);

	const isMobile = computed<boolean>(() =>
		isMobileDevice(window?.navigator?.userAgent)
	);

	function handleSubmit(
		callback: () => void
	): null | ((provider: string) => void) {
		if (import.meta.server) return null;

		return (provider: string) => {
			const url = `${ORIGIN}/api/auth/${provider}`;
			const options = `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},top=${top.value},left=${left.value}`;

			const popup = isMobile.value
				? window.open(url)
				: window.open(url, 'popup', options);

			const popupInterval = setInterval(async () => {
				if (popup?.closed) {
					clearInterval(popupInterval);
					callback();
				}
			}, 100);
		};
	}

	return { handleSubmit };
}
